export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_strike_details.page.viewed',
  },
  SAVE_BUTTON: {
    CLICKED: 'worker_strike_details.save_button.clicked',
  },
}
